import { useTranslation } from "react-i18next";
import { useState } from "react";
import styles from "./ClearResponsesModal.module.css";

export default function ClearResponsesModal({ surveyID, onConfirm, onCancel, isLoading }) {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState("");
    const [error, setError] = useState("");

    function handleConfirm() {
        if (inputValue.trim() === "") {
            setError(t("clearResponses.modal.idRequired", { defaultValue: "ID ankiety jest wymagane" }));
            return;
        }

        if (inputValue.trim() !== surveyID) {
            setError(t("clearResponses.modal.idMismatch", { defaultValue: "ID ankiety jest nieprawidłowe" }));
            return;
        }

        onConfirm(inputValue.trim());
    }

    return (
        <div className={styles.overlay} onClick={onCancel}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h2>{t("clearResponses.modal.title", { defaultValue: "Wyczyść odpowiedzi" })}</h2>
                    <button
                        className={styles.closeButton}
                        onClick={onCancel}
                        disabled={isLoading}
                        aria-label="Close"
                    >
                        ✕
                    </button>
                </div>

                <div className={styles.content}>
                    <div className={styles.warning}>
                        <span className={styles.warningIcon}>⚠️</span>
                        <p>
                            {t("clearResponses.modal.warning", {
                                defaultValue:
                                    "Usunięcie bazy danych jest nieodwracalne! Wszystkie odpowiedzi dla tej ankiety będą trwale usunięte.",
                            })}
                        </p>
                    </div>

                    <div className={styles.formGroup}>
                        <label htmlFor="surveyIdInput">
                            {t("clearResponses.modal.idLabel", {
                                defaultValue: "Wpisz ID ankiety aby potwierdzić:",
                            })}
                        </label>
                        <input
                            id="surveyIdInput"
                            type="text"
                            value={inputValue}
                            onChange={(e) => {
                                setInputValue(e.target.value);
                                setError("");
                            }}
                            placeholder={surveyID}
                            disabled={isLoading}
                            className={styles.input}
                            autoFocus
                        />
                        {error && <div className={styles.error}>{error}</div>}
                        <small className={styles.hint}>
                            <code>{surveyID}</code>
                        </small>
                    </div>
                </div>

                <div className={styles.footer}>
                    <button
                        className={styles.cancelButton}
                        onClick={onCancel}
                        disabled={isLoading}
                    >
                        {t("common.cancel", { defaultValue: "Anuluj" })}
                    </button>
                    <button
                        className={styles.confirmButton}
                        onClick={handleConfirm}
                        disabled={isLoading || !inputValue}
                    >
                        {isLoading
                            ? t("clearResponses.modal.deleting", { defaultValue: "Usuwanie..." })
                            : t("clearResponses.modal.confirm", { defaultValue: "Wyczyść odpowiedzi" })}
                    </button>
                </div>
            </div>
        </div>
    );
}
